import { Reveal } from "./Reveal";

const SectionHeading = ({ eyebrow, title, lead, align = "center" }) => (
  <Reveal
    className={`mb-12 md:mb-16 ${align === "center" ? "text-center" : "text-left"}`}
  >
    <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-gold">
      {eyebrow}
    </p>
    <h2 className="font-display text-4xl uppercase leading-none tracking-wide text-white sm:text-5xl lg:text-6xl">
      {title}
    </h2>
    {lead && (
      <p
        className={`mt-4 max-w-2xl text-sm leading-relaxed text-white/70 sm:text-base ${
          align === "center" ? "mx-auto" : ""
        }`}
      >
        {lead}
      </p>
    )}
  </Reveal>
);

export default SectionHeading;
